import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { GoogleLogo, User, Envelope, LockKey } from "@phosphor-icons/react";

export default function Register() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data.user);
      toast.success("Conta criada!");
      navigate("/");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Erro ao registar");
    } finally {
      setLoading(false);
    }
  }

  function googleLogin() {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }

  return (
    <div className="pt-16 min-h-screen flex items-center justify-center px-5 py-10 hero-grad">
      <div className="w-full max-w-md bg-[#121217] border border-white/5 rounded-2xl p-8 fadeup" data-testid="register-card">
        <div className="font-mono-accent text-xs text-[#E63946] mb-2">◢ NOVA CONTA</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Junta-te à comunidade</h1>
        <p className="text-sm text-zinc-400 mt-2">Cria a tua conta para começar a colecionar mangás.</p>

        <Button
          type="button"
          onClick={googleLogin}
          variant="outline"
          className="w-full mt-6 bg-white text-zinc-900 hover:bg-zinc-100 border-0"
          data-testid="google-register-btn"
        >
          <GoogleLogo size={20} weight="bold" className="mr-2" /> Continuar com Google
        </Button>

        <div className="my-6 flex items-center gap-4">
          <div className="flex-1 h-px bg-white/10" />
          <div className="font-mono-accent text-[10px] text-zinc-500">OU EMAIL</div>
          <div className="flex-1 h-px bg-white/10" />
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="name">Nome</Label>
            <div className="relative mt-1">
              <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
              <Input id="name" name="name" required value={form.name} onChange={handleChange} className="pl-9 bg-[#1C1C22] border-white/10" data-testid="register-name-input" />
            </div>
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <div className="relative mt-1">
              <Envelope size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
              <Input id="email" name="email" type="email" required value={form.email} onChange={handleChange} className="pl-9 bg-[#1C1C22] border-white/10" data-testid="register-email-input" />
            </div>
          </div>
          <div>
            <Label htmlFor="password">Palavra-passe (mín. 6)</Label>
            <div className="relative mt-1">
              <LockKey size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
              <Input id="password" name="password" type="password" required minLength={6} value={form.password} onChange={handleChange} className="pl-9 bg-[#1C1C22] border-white/10" data-testid="register-password-input" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full btn-crimson" data-testid="register-submit-btn">
            {loading ? "A criar..." : "Criar Conta"}
          </Button>
        </form>

        <p className="text-sm text-zinc-400 mt-6 text-center">
          Já tens conta?{" "}
          <Link to="/login" className="text-[#E63946] hover:underline" data-testid="goto-login-link">Entra</Link>
        </p>
      </div>
    </div>
  );
}
